import {InMemoryCache} from '@apollo/client';
import dataIdFromObject from 'src/internal/shared/apollo/dataIdFromObject';

import type {GraphQlConfig} from 'src/internal/config/types';
import type {PossibleTypes} from 'src/internal/shared/config/types';

const createCache = (schemas: GraphQlConfig['schemas']): InMemoryCache => {
  const possibleTypes: PossibleTypes = {};
  const anonymousTypes: string[] = [];

  for (const schemaKey in schemas) {
    if (schemas.hasOwnProperty(schemaKey)) {
      const schema = schemas[schemaKey];

      if (schema?.possibleTypes) {
        for (const key in schema.possibleTypes) {
          if (schema.possibleTypes.hasOwnProperty(key)) {
            possibleTypes[key] = schema.possibleTypes[key];
          }
        }
      }

      if (schema?.anonymousTypes) {
        for (const anonymousType of schema.anonymousTypes) {
          anonymousTypes.push(anonymousType);
        }
      }
    }
  }

  return new InMemoryCache({
    possibleTypes,
    dataIdFromObject,
    typePolicies: Object.fromEntries(
      anonymousTypes.map((type) => [type, {merge: true}]),
    ),
  });
};

export default createCache;
